// extracted by mini-css-extract-plugin
export default {"container":"SearchBar-module__container__gMeJB","inputWrapper":"SearchBar-module__inputWrapper__bcPLn"};